import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const TABS = [
  { key: "terms", ar: "الشروط والأحكام", en: "Terms & Conditions" },
  { key: "exchange", ar: "الاستبدال والاسترجاع", en: "Exchange & Returns" },
  { key: "privacy", ar: "الخصوصية", en: "Privacy" },
  { key: "shipping", ar: "الشحن والتوصيل", en: "Shipping & Delivery" },
  { key: "alteration", ar: "تعديل المقاسات", en: "Alterations" },
];

export default function Policies() {
  const { lang } = useLang();
  const ar = lang === "ar";
  const [s, setS] = useState(null);
  const [tab, setTab] = useState("terms");
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <div className="py-24 text-center text-text-muted">…</div>;
  const pol = s.policies?.[tab];

  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-10 md:py-16 fade-in">
      <span className="text-xs tracking-luxe uppercase text-accent">RNF_Line</span>
      <h1 className="font-display text-4xl mt-2 mb-6">{ar ? "السياسات" : "Policies"}</h1>

      <div className="flex gap-2 mb-8 border-b border-border overflow-x-auto">
        {TABS.map((tb) => (
          <button key={tb.key} onClick={() => setTab(tb.key)} data-testid={`policy-tab-${tb.key}`}
            className={`whitespace-nowrap flex-shrink-0 px-4 py-2.5 text-sm -mb-px border-b-2 transition-colors ${tab === tb.key ? "border-primary text-primary" : "border-transparent text-text-muted hover:text-primary"}`}>
            {ar ? tb.ar : tb.en}
          </button>
        ))}
      </div>

      <h2 className="font-display text-2xl mb-4">{pol?.title}</h2>
      <div className="bg-surface border border-border p-6 md:p-8 leading-relaxed whitespace-pre-line" data-testid="policy-content">
        {pol?.content}
      </div>
    </div>
  );
}
